import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PauseCircle, PlayCircle, Download, Check } from "lucide-react";
import { PROGRAM_LABELS, Disclaimer, CoachBadge } from "@/components/program/shared";

export const Profile = ({ accessId, access, ent, onChange }) => {
  const [busy, setBusy] = useState(false);
  const plan = ent?.plan;

  const togglePause = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/programs/${accessId}/pause`, { reason: "" }); toast.success(`Program ${data.status.toLowerCase()}`); onChange(); }
    catch { toast.error("Failed"); }
    setBusy(false);
  };

  const exportProgram = async () => {
    const { data } = await api.get(`/programs/${accessId}/export`);
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "cg-labz-program.json"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="pt-6" data-testid="program-profile">
      <div className="mono-label">Your account</div>
      <h1 className="font-serif text-4xl text-white mb-4">Profile</h1>

      <div className="glass rounded-2xl p-5 mb-4">
        <CoachBadge />
        <div className="mt-4 grid grid-cols-2 gap-3 font-mono text-sm">
          <div><div className="text-[10px] uppercase tracking-widest text-slate-500">Program</div>{PROGRAM_LABELS[access.program_type]}</div>
          <div><div className="text-[10px] uppercase tracking-widest text-slate-500">Duration</div>{access.duration_weeks} weeks</div>
          <div><div className="text-[10px] uppercase tracking-widest text-slate-500">Status</div><span className="text-cyan-300">{access.status}</span></div>
          <div><div className="text-[10px] uppercase tracking-widest text-slate-500">Source</div>{(access.source || "").replace(/_/g, " ")}</div>
        </div>
      </div>

      {plan && (
        <div className="glass rounded-2xl p-5 mb-4" data-testid="membership-benefits">
          <div className="mono-label mb-2">Membership · {plan.name}</div>
          <ul className="space-y-1.5">
            {(plan.benefits || []).map((b) => <li key={b} className="flex items-center gap-2 text-[13px] text-slate-300"><Check size={13} className="text-cyan-400" /> {b}</li>)}
          </ul>
        </div>
      )}

      <div className="grid sm:grid-cols-3 gap-3">
        <Button variant="outline" onClick={togglePause} disabled={busy} data-testid="pause-program">
          {access.status === "PAUSED" ? <><PlayCircle size={15} className="mr-2" /> Resume</> : <><PauseCircle size={15} className="mr-2" /> Pause program</>}
        </Button>
        <Button variant="outline" onClick={exportProgram} data-testid="export-program"><Download size={15} className="mr-2" /> Export program</Button>
      </div>

      <Disclaimer className="mt-8" />
    </div>
  );
};
